import React from "react";
import ListItem from "@material-ui/core/ListItem";
import {NavLink} from "react-router-dom";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import IconExpandLess from "@material-ui/icons/ExpandLess";
import {useStyles} from "./NavListItems/styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReportQueueIcon from "./NavListItems/ReportQueueIcon";
import {Badge} from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

const NavStatusBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge-success': {
    backgroundColor: green[500],
    color: 'white',
  },
    '& .MuiBadge-badge-warning': {
    backgroundColor: theme.palette.amano.warnings.warning,
    color: 'white',
  },
}));

const customIconComponentMap = {
    // Add more custom icons below by using the following example: sample1: <Sample1Icon />, sample2: <Sample2Icon />,
    reportQueueIcon: <ReportQueueIcon />,
}


const getIconElement = (icon, customIcon, MaterialUIIcon, className, key, faIconsize, muiIconSize) => {
    if (customIcon) {
        return customIconComponentMap[customIcon] ?? null;
    } else if (icon) {
        return <FontAwesomeIcon icon={icon} className={className} key={key} size={faIconsize}/>;
    } else if (MaterialUIIcon) {
        return <MaterialUIIcon className={className} key={key} fontSize={muiIconSize}/>;
    }
    return null;
}

export const NavlistItem = ({id, text,customIcon, icon, muiIcon, path, childrennew, childrenState, handleClick, key, badgeStatus}) => {
    const classes = useStyles();
    const IconElement = getIconElement(icon, customIcon, muiIcon, classes.navLink, key, "2x", "large");


    return (
      <ListItem
          data-id={id}
          data-expanded={childrennew ? !!childrenState[text] : undefined}
          className={classes.navLink}
          component={path && path !== "" && NavLink}
          button={!path || path === ""}
          to={`${path}`}
          key={key}
          onClick={() => !!childrennew && handleClick(text)}
      >
          <ListItemIcon>
              <NavStatusBadge
                badgeContent={badgeStatus?.count}
                invisible={badgeStatus?.count === 0}
                classes={{
                  badge: badgeStatus?.type === 'success'
                      ? 'MuiBadge-badge-success' :
                      badgeStatus?.type === 'warning'
                      ? 'MuiBadge-badge-warning' : null
                }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                  {IconElement}
              </NavStatusBadge>
          </ListItemIcon>

          <ListItemText key={key} primary={text} />

          <ListItemSecondaryAction className={classes.caretIcon}>
              {!!childrennew && !childrenState[text] && (
                  <IconButton onClick={() => handleClick(text)}>
                      <IconExpandMore />
                  </IconButton>
              )}
              {!!childrennew && childrenState[text] && (
                  <IconButton onClick={() => handleClick(text)}>
                      <IconExpandLess />
                  </IconButton>
              )}
          </ListItemSecondaryAction>
      </ListItem>
  );
};

